import React from "react";
import "../../style/common/headerBar.scss";
import { useNavigate } from "react-router-dom";
import { routeToPage } from "../../util/RouteToPage";
import PagePath from "../../util/RoutePagePath";
import { useSelector } from "react-redux";
import ShoppingCart from "../../icon/Bag";
import logo from "../../image/logo.png";

const HeaderBar = () => {
  const navigate = useNavigate();
  const cartItems = useSelector((state) => state.cart.cartItems);
  const cartNumber = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <React.Fragment>
      <header className="bg-btn text-white backdrop-blur-md">
        <div className="mx-auto flex h-[88px] max-w-container items-center justify-between px-16">
          {/* LEFT */}
          <div className="flex items-center gap-14">
            {/* logo */}
            <h1
              onClick={() => {
                routeToPage(navigate, PagePath.HOME_PAGE);
              }}
              className="cursor-pointer text-[30px] font-extrabold tracking-[6px] transition hover:opacity-70"
            >
              Elvorloy
            </h1>
            {/* nav */}
            <ul className="flex items-center gap-10 text-[13px] uppercase tracking-[2px]">
              <li
                onClick={() => routeToPage(navigate, PagePath.ABOUT_PAGE)}
                className="cursor-pointer transition hover:text-black"
              >
                About
              </li>

              <li
                onClick={() => routeToPage(navigate, PagePath.CONTACT_PAGE)}
                className="cursor-pointer transition hover:text-black"
              >
                Contact
              </li>

              <li
                onClick={() => routeToPage(navigate, PagePath.SHIPPING_PAGE)}
                className="cursor-pointer transition hover:text-black"
              >
                Shipping
              </li>

              <li
                onClick={() => routeToPage(navigate, PagePath.TERMS_PAGE)}
                className="cursor-pointer transition hover:text-black"
              >
                Terms
              </li>

              <li
                onClick={() => routeToPage(navigate, PagePath.PRIVACY_PAGE)}
                className="cursor-pointer transition hover:text-black"
              >
                Privacy
              </li>
            </ul>
          </div>

          {/* RIGHT */}
          <div className="flex items-center gap-8">
            {/* cart */}
            <div
              className="group relative cursor-pointer"
              onClick={() => {
                routeToPage(navigate, PagePath.CART_PAGE);
              }}
            >
              <div>
                <ShoppingCart
                  size={26}
                  color="#fff"
                  className="transition duration-300 group-hover:scale-110"
                />
              </div>

              <div className="absolute -right-2 -top-2 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-white px-1 text-[9px] font-medium text-btn">
                {cartNumber}
              </div>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default HeaderBar;
